import { render, staticRenderFns } from "./ParcelamentoPertView.vue?vue&type=template&id=466ac123&"
import script from "./ParcelamentoPertView.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoPertView.vue?vue&type=script&lang=js&"
import style0 from "./ParcelamentoPertView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports